import { Add } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import AddEmpolyeess from './AddEmpolyeess';
import AddMoney from './AddMoney';
import WalletsReports from './WalletsReports';


const AddWalletEmpolyee = () => {
  const [activeTab, setActiveTab] = useState('Add Employee');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // ================== Tabs Data ==================
  const tabContent = {
    "Add Employee": <AddEmpolyeess />,
    "Add Money": <AddMoney />,
    "Reports": <WalletsReports />,
  };

  return (
    <div className="container-fluid">
      <div className="Row">
        <div className="col-lg-2"></div>
        <div className="Col-lg-7">
          {/* Left Section */}
          <div className="left-column">
            <div className="tabs-wrapperpayment">
              {/* Tab Buttons */}
              <div className="overviewbuttonsyy" style={{ textAlign: 'center' }}>
                {Object.keys(tabContent).map((label) => (
                  <button
                    style={{
                      backgroundColor: activeTab === label ? '#b15dc6' : '#d9d9d9',
                      border: 'none',
                      borderRadius: '10px',
                      width: '150px',
                      height: '40px',
                      color: 'black',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s ease',
                      margin: '10px',
                    }}
                    key={label}
                    className={`overviewbuttons ${activeTab === label ? "active" : ""}`}
                    onClick={() => setActiveTab(label)}
                  >
                    {label}
                  </button>
                ))}
              </div>

              {/* Tab Content */}
              <div
                className="tab-content"
                style={{
                  overflow: 'auto',
                  height: isMobile ? '700px' : '520px',
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  maxWidth: '944px',
                }}
              >
                {tabContent[activeTab]}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddWalletEmpolyee;
